// extracted by mini-css-extract-plugin
module.exports = {"blockInfoView":"InfoView_blockInfoView__3spr8"};